(function () {
  const MAX_SCALE = 3;    // logo size at top of page
  const MIN_SCALE = 1;    // logo size when fully scrolled
  const SCROLL_RANGE = 300; // px of scroll to complete the transition

  function getLogoImg() {
    return (
      document.querySelector('.header__heading-logo') ||
      document.querySelector('.header__logo img') ||
      document.querySelector('header img[src*="logo"]') ||
      document.querySelector('.site-header__logo img')
    );
  }

  function createOverlay(logoImg) {
    const overlay = document.createElement('div');
    overlay.className = 'scroll-logo-overlay';
    const clone = logoImg.cloneNode(true);
    overlay.appendChild(clone);
    document.body.appendChild(overlay);
    return { overlay, clone };
  }

  function init() {
    const logoImg = getLogoImg();
    if (!logoImg) return;

    const { overlay, clone } = createOverlay(logoImg);
    logoImg.style.opacity = '0'; // hide original, show overlay

    function onScroll() {
      const scrollY = window.scrollY || window.pageYOffset;
      const progress = Math.min(scrollY / SCROLL_RANGE, 1);
      const scale = MAX_SCALE - (MAX_SCALE - MIN_SCALE) * progress;
      clone.style.transform = `scale(${scale})`;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
